import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=34f007be&scoped=true&"
import script from "./Branding.vue?vue&type=script&lang=js&"
export * from "./Branding.vue?vue&type=script&lang=js&"
import style0 from "./Branding.vue?vue&type=style&index=0&id=34f007be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f007be",
  null
  
)

export default component.exports